import { getUserFacingApiMessage } from "./getUserFacingApiMessage";

const TECHNICAL_MESSAGE =
  /^(dashboard_job_|network error|axios|econnrefused|request failed|internal server error)/i;

function looksTechnical(message) {
  const msg = String(message || "").trim();
  if (!msg) return true;
  if (msg.startsWith("{") || msg.startsWith("[")) return true;
  if (TECHNICAL_MESSAGE.test(msg)) return true;
  return false;
}

/**
 * Mensagem amigável para erros de carregamento das abas do dashboard.
 * Nunca expõe detalhes técnicos (códigos internos, JSON, stack).
 */
export function formatDashboardUserError(error, t) {
  if (!error) return null;

  if (typeof error.userFacing === "string" && error.userFacing.trim()) {
    return error.userFacing.trim();
  }

  const rawMessage = String(error?.message || error?.error || "").trim();

  if (rawMessage === "dashboard_job_timeout") {
    return t("dashboardPage.shared.reportStillProcessing", {
      defaultValue:
        "O relatório completo ainda está sendo preparado. Você será avisado quando estiver pronto — pode continuar usando o sistema.",
    });
  }

  if (rawMessage === "dashboard_job_failed") {
    return t("dashboardPage.shared.reportFailed", {
      defaultValue:
        "Não foi possível concluir o relatório desta vez. Tente atualizar a página ou escolha um período menor.",
    });
  }

  const status = error?.response?.status ?? error?.status;
  if (
    status === 503 ||
    status === 504 ||
    /503|504|service unavailable|gateway timeout|timeout|timed?\s*out/i.test(rawMessage)
  ) {
    return t("dashboardPage.loadTimeout", {
      defaultValue:
        "O servidor demorou demais para montar os gráficos. Tente um período menor ou aguarde alguns minutos e atualize a página.",
    });
  }

  const api = getUserFacingApiMessage(error);
  if (api.message && !looksTechnical(api.message)) {
    return api.message;
  }

  if (rawMessage && !looksTechnical(rawMessage)) {
    return rawMessage;
  }

  return t("dashboardPage.shared.loadError", {
    defaultValue:
      "Não foi possível carregar os dados desta aba. Tente atualizar a página ou escolha um período menor.",
  });
}
